module.exports = __webpack_public_path__ + "media/images/close-btn-black-cdd9ce06094db4ae5e1aba677bb90d66.svg";